import { render } from "./HeaderContainer.vue?vue&type=template&id=b9f356d2"
import script from "./HeaderContainer.vue?vue&type=script&lang=js"
export * from "./HeaderContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__